import { RecentTimelineItemTypeFilterEnum } from "web_myplann/Infrastructure/Api/Api";
import type { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import {
	DEFAULT_TIMELINE_FILTER,
	type TimelineFilterState,
} from "web_myplann/NotificationCenter/Atoms/timelineFilterAtom";
import {
	NOTIFICATION_CENTER_TABS,
	type NotificationCenterTab,
} from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import {
	horizonResource,
	typeResource,
} from "web_myplann/NotificationCenter/Utils/filterLabels";

type TranslateFn = ReturnType<typeof useResource>["t"];

export const timelineFilterSummary = (
	filter: TimelineFilterState,
	tab: NotificationCenterTab,
	t: TranslateFn,
): string => {
	const isUpcoming = tab === NOTIFICATION_CENTER_TABS.Upcoming;

	const type = isUpcoming ? filter.upcomingType : filter.recentType;
	const typePart =
		type !== RecentTimelineItemTypeFilterEnum.All
			? t(typeResource(type))
			: undefined;

	const horizonPart =
		isUpcoming && filter.horizon !== DEFAULT_TIMELINE_FILTER.horizon
			? t(horizonResource(filter.horizon))
			: undefined;

	return [typePart, horizonPart]
		.filter((part) => part !== undefined)
		.join(", ");
};
